// can be reused later for internet
export const SHIPPING_INFO = `*Shipping will now be charged as a flat rate per item. Shipping is calculated based on the full price of the item. This charge will be included on your invoice and order summary. Shipping charges vary by vendor. For more information on charges, please visit FAQs.`;

export const TAX_EXEMPT_INFO = `One or more items have tax applied. this could be due to the location shipped to, the item type, or if a specific vendor does not have your information on file`;

export const BACKORDER_ALL_ITEMS =
  'All items added to your cart are on order and will ship when it is in stock.';

export const BACKORDER_PARTIAL_ITEMS =
  '${0} item(s) added to your cart are on order and will ship when it is in stock.';

export const DISCOUNT_INFO =
  'Shipping and Taxes are calculated based upon regular Price. Promo codes can not be combined.';

export const PRODUCT_WRONG_WINDOW =
  'The product does not belong to active buying window. Please select a correct buying window';

export const ADDRESS_BOOK_INFO = `The default address is set for only your account. Please input only unique address location information below. Your addresses will be validated when entered. Please do not attempt to enter attention or PO information in your address. Do not add Wholesaler addresses to your address book. You can search the ship-to dropdown for Wholesaler addresses. The Wholesaler default address is only available when using Decision Points and is starred when doing a normal search of Wholesaler addresses.`;

export const WSLR_ADDRESS_BOOK_INFO = `This is the %WSLR_NAME% Shared Address Book. The default address is set for the entire organization and is used by others to create orders for this organization. Please input only unique address location information below. Your addresses will be validated when entered. Please do not attempt to enter attention or PO information in your address.`;

export const SAFARI_NOT_SUPPORTED =
  'Please use Chrome on a desktop to add a new Credit Card.';

export const ORDER_NOTES_INFO =
  'Enter internal notes for your personal use to show up on your packing slip and order history. These notes are not used by the Supplier.';
